export const TEST_ID = 'chemicalsPage';

export const LIBRARY_TAB = 'library';

export const MIXES_TAB = 'mixes';
